import axios from 'axios';

let currentVersion = null;
let checkInterval = null;

/**
 * 初始化版本检测
 * @param {number} interval - 检测间隔，单位毫秒，默认60秒
 */
export const initVersionCheck = (interval = 60000) => {
  // 立即获取当前版本
  fetchVersion();
  
  // 设置定时检测
  if (checkInterval) {
    clearInterval(checkInterval);
  }
  
  checkInterval = setInterval(checkVersion, interval);
};

/**
 * 获取初始版本号
 */
const fetchVersion = async () => {
  try {
    const timestamp = new Date().getTime();
    const response = await axios.get(`/version.json?_t=${timestamp}`);
    currentVersion = response.data.version;
    console.log('当前应用版本:', currentVersion);
  } catch (error) {
    console.error('获取版本信息失败:', error);
  }
};

/**
 * 检测版本更新
 */
const checkVersion = async () => {
  if (!currentVersion) {
    await fetchVersion();
    return;
  }
  
  try {
    const timestamp = new Date().getTime();
    const response = await axios.get(`/version.json?_t=${timestamp}`, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
    
    const newVersion = response.data.version;
    
    // 如果版本不一致，刷新页面
    if (newVersion && newVersion !== currentVersion) {
      console.log(`检测到新版本: ${newVersion}，当前版本: ${currentVersion}，正在刷新...`);
      window.location.reload(true);
    }
  } catch (error) {
    console.error('版本检测失败:', error);
  }
};

/**
 * 停止版本检测
 */
export const stopVersionCheck = () => {
  if (checkInterval) {
    clearInterval(checkInterval);
    checkInterval = null;
  }
}; 